/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown> }} Automation_Event_LabelInputs */

const en_automation_event_label = /** @type {(inputs: Automation_Event_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.event === "requirements.ready") return /** @type {LocalizedString} */ (`Case requirements checked`);
	if (i?.event === "requirements.recommended") return /** @type {LocalizedString} */ (`Recommended documents checked`);
	if (i?.event === "requirements.blocked") return /** @type {LocalizedString} */ (`Step requirements pending`);
	return /** @type {LocalizedString} */ (`${i?.event}`)
	
};

const pt_br2_automation_event_label = /** @type {(inputs: Automation_Event_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.event === "requirements.ready") return /** @type {LocalizedString} */ (`Requisitos do caso verificados`);
	if (i?.event === "requirements.recommended") return /** @type {LocalizedString} */ (`Documentos recomendados verificados`);
	if (i?.event === "requirements.blocked") return /** @type {LocalizedString} */ (`Requisitos da etapa pendentes`);
	return /** @type {LocalizedString} */ (`${i?.event}`)
	
};

/**
* | event | output |
* | --- | --- |
* | "requirements.ready" | "Case requirements checked" |
* | "requirements.recommended" | "Recommended documents checked" |
* | "requirements.blocked" | "Step requirements pending" |
* | * | "{event}" |
*
* @param {Automation_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_event_label = /** @type {((inputs: Automation_Event_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Event_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_event_label(inputs)
	return pt_br2_automation_event_label(inputs)
});